import {
  MatDialog,
  MatPaginator,
  MatTableDataSource,
  MatSelectChange
} from "@angular/material";
import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";

import { IBranch } from "src/app/interfaces/branch";
import { IConfirm } from "src/app/interfaces/confirm";
import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";
import { BIDService } from "src/app/services/common/bid.service";
import { ICourseHistory } from "src/app/interfaces/course-history";
import { ErrorsService } from "src/app/services/common/errors.service";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { CourseHistoryEntryComponent } from "../course-history-entry/course-history-entry.component";
import { CourseHistoryService } from "src/app/services/http/business/course-history/course-history.service";

@Component({
  selector: "app-course-history-list",
  templateUrl: "./course-history-list.component.html",
  styleUrls: ["./course-history-list.component.css"]
})
export class CourseHistoryListComponent implements OnInit {
  pageSize: number;
  isOwner: boolean;
  pageIndex: number;
  branchList: IBranch;
  compnayList: ICompany;
  branchSelected: string;
  companySelected: string;
  courseHistoryList: ICourseHistory;
  displayedColumns: string[] = [
    this.translate.get("label.description"),
    "function"
  ];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private cidService: CIDService,
    private bidService: BIDService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private branchService: BranchService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private courseHistoryService: CourseHistoryService
  ) { }

  ngOnInit() {
    this.courseHistoryService.change.subscribe(() => {
      this.checkOwner();
      this.getCompanyList();
      this.getBranchList();
    });
    this.init();
    this.companySelected = this.cidService.getCID();
    this.checkOwner();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
        this.getBranchList();
      }
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.compnayList = res.DataList;
    });
  }

  getBranchList() {
    this.branchService.list(true).subscribe(res => {
      this.branchList = res.DataList;
    });
  }

  init() {
    this.courseHistoryService.list().subscribe(
      res => {
        this.dataSource = res.DataList;
        this.paginator.length = res.Total;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  paginatorEvent(event) {
    this.courseHistoryService
      .list(event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.pageIndex = event.pageIndex + 1;
        this.pageSize = event.pageSize;
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

  add() {
    this.dialog
      .open(CourseHistoryEntryComponent)
      .afterClosed()
      .subscribe(() => {
        this.courseHistoryService.list().subscribe(re => {
          this.paginator.pageIndex = 0;
          this.dataSource = new MatTableDataSource(re.DataList);
          this.paginator.length = re.Total;
        });
        this.companySelected = this.cidService.getCID();
      });
  }

  loadBranch(e: any) {
    this.cidService.setCID(e);
    this.bidService.setBID("");
    this.dataSource = null;
    this.paginator.length = 0;
    this.getBranchList();
  }

  loadDataTable(e: MatSelectChange) {
    this.bidService.setBID(e.value);
    this.courseHistoryService.list().subscribe(res => {
      this.dataSource = new MatTableDataSource(res.DataList);
      this.paginator.length = res.Total;
    });
  }

  edit(e: ICourseHistory) {
    this.dataSource = null;
    this.courseHistoryService.getById(e.Id).subscribe(res => {
      this.dialog
        .open(CourseHistoryEntryComponent, {
          data: res
        })
        .afterClosed()
        .subscribe(() => {
          this.courseHistoryService
            .list(this.pageIndex, this.pageSize)
            .subscribe(res => {
              this.dataSource = new MatTableDataSource(res.DataList);
              this.paginator.length = res.Total;
            });
          this.companySelected = this.cidService.getCID().toString();
        });
    });
  }

  delete(data: ICourseHistory) {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.courseHistory") + " " + data.Description
      }),
      alert:null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.courseHistoryService.delete(data.Id).subscribe(
          () => {
            this.courseHistoryService
              .list(this.pageIndex, this.pageSize)
              .subscribe(res => {
                this.dataSource = new MatTableDataSource(res.DataList);
                this.paginator.length = res.Total;
              });
          },
          err => {
            this.errorService.recordHasBennUsed(err);
          }
        );
      }
    });
  }

  ngOnDestroy() {
    if (this.isOwner) {
      // this.cidService.setCID("");
      this.bidService.setBID("");
    }
  }
}
